module.exports = __webpack_public_path__ + "assets/img/nav.9f355b2c.png";